import type { v4, Manifest } from '@sap/ux-specification-types';
import { descriptionSrcURL, syncRule, validity } from '../../../common/decoration/decorators';
import { getColumnsPathForOP } from '../../application';
import type { Importance } from 'sap/uxap/library';

export class ActionAfterExecutionConfigurationOP implements v4.ActionAfterExecutionConfiguration {
    @syncRule({
        manifest: {
            path: (pageName: string[], manifest: Manifest, sectionId: string, columnKey): string =>
                getColumnsPathForOP(pageName, manifest, sectionId, columnKey) + '/afterExecution'
        }
    })
    @descriptionSrcURL('https://ui5.sap.com/#/topic/2c65f07f44094012a511d6bd83f50f2d')
    navigateToInstance?: boolean;

    @syncRule({
        manifest: {
            path: (pageName: string[], manifest: Manifest, sectionId: string, columnKey): string =>
                getColumnsPathForOP(pageName, manifest, sectionId, columnKey) + '/afterExecution'
        }
    })
    enableAutoScroll?: boolean;
}

export class ObjectPageTableColumn implements v4.ObjectPageTableColumn {
    @syncRule({
        manifest: {
            path: getColumnsPathForOP
        }
    })
    @validity({
        since: '1.84.0'
    })
    @descriptionSrcURL('https://ui5.sap.com/api/sap.ui.core.CSSSize')
    width?: string;

    @syncRule({
        manifest: {
            path: getColumnsPathForOP
        }
    })
    @validity({
        since: '1.85.0'
    })
    availability?: v4.Availability;

    @syncRule({
        manifest: {
            path: getColumnsPathForOP
        }
    })
    @validity({
        since: '1.120.0'
    })
    @descriptionSrcURL('https://ui5.sap.com/#/topic/c0f6592a592e47f9bb6d09900de47412')
    widthIncludingColumnHeader?: boolean;
}

export class ObjectPageTableColumnAction extends ObjectPageTableColumn implements v4.ObjectPageTableColumnAction {}

export class PositionOP implements v4.PositionOP {
    @syncRule({
        manifest: {
            path: (pageName: string[], manifest: Manifest, sectionId: string, columnKey): string =>
                getColumnsPathForOP(pageName, manifest, sectionId, columnKey) + '/position'
        }
    })
    @validity({
        since: '1.84.0'
    })
    anchor?: string;
    @syncRule({
        manifest: {
            path: (pageName: string[], manifest: Manifest, sectionId: string, columnKey): string =>
                getColumnsPathForOP(pageName, manifest, sectionId, columnKey) + '/position'
        }
    })
    @validity({
        since: '1.84.0'
    })
    placement: v4.Placement;
}

export class TableCustomColumnOP implements v4.TableCustomColumnOP {
    @syncRule({
        manifest: {
            path: getColumnsPathForOP
        }
    })
    @validity({
        since: '1.84.0'
    })
    position?: PositionOP;

    @syncRule({
        manifest: {
            path: getColumnsPathForOP
        }
    })
    @validity({
        since: '1.84.0'
    })
    header: string;

    @syncRule({
        manifest: {
            path: getColumnsPathForOP
        }
    })
    @validity({
        since: '1.84.0'
    })
    @descriptionSrcURL('https://ui5.sap.com/api/sap.ui.core.CSSSize')
    width?: string;

    @syncRule({
        manifest: {
            path: getColumnsPathForOP
        }
    })
    @validity({
        since: '1.84.0'
    })
    template: string;

    @syncRule({
        manifest: {
            path: getColumnsPathForOP
        }
    })
    @validity({
        since: '1.86.0'
    })
    horizontalAlign?: v4.HorizontalAlign;

    @syncRule({
        manifest: {
            path: getColumnsPathForOP
        }
    })
    @validity({
        since: '1.84.0'
    })
    availability?: v4.Availability;

    @syncRule({
        manifest: {
            path: getColumnsPathForOP
        }
    })
    @validity({
        since: '1.85.0'
    })
    properties?: v4.ColumnPropertiesType;

    @syncRule({
        manifest: {
            path: getColumnsPathForOP
        }
    })
    @validity({
        since: '1.120.0'
    })
    required?: boolean;

    @syncRule({
        manifest: {
            path: getColumnsPathForOP
        }
    })
    @validity({
        since: '1.120.0'
    })
    importance?: Importance;

    @syncRule({
        manifest: {
            path: getColumnsPathForOP
        }
    })
    @validity({
        since: '1.130.0'
    })
    tooltip?: string;
}
